(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xblanks-retail-packs"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initRetailPacks(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panels = [...root.querySelectorAll('[data-pack-panel]')];
    if (!panels.length) return;
    const showPanel = (key) => panels.forEach(panel => { panel.hidden = panel.dataset.packPanel !== key; });
    const fromHash = panels.find(panel => '#' + panel.id === location.hash);
    showPanel(fromHash ? fromHash.dataset.packPanel : 'trio');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.target.toggleAttribute('data-builder-visible', entry.isIntersecting));
      }, { rootMargin: '-90px 0px 0px', threshold: 0 });
      panels.forEach(panel => observer.observe(panel));
    } else {
      panels.forEach(panel => panel.setAttribute('data-builder-visible', ''));
    }
    root.querySelectorAll('[data-pack-select]').forEach(link => link.addEventListener('click', () => showPanel(link.dataset.packSelect)));
    window.addEventListener('hashchange', () => {
      const panel = panels.find(candidate => '#' + candidate.id === location.hash);
      if (panel) showPanel(panel.dataset.packPanel);
    });
  }
  document.querySelectorAll('[data-retail-packs]').forEach(initRetailPacks);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-retail-packs]').forEach(initRetailPacks));
})();

  } catch(e) { console.error(e); }
})();
})();
